import p from "./ghl-ui.es1589.js";
import c from "./ghl-ui.es1590.js";
import s from "./ghl-ui.es1586.js";
import f from "./ghl-ui.es1587.js";
import l from "./ghl-ui.es1588.js";
import n from "./ghl-ui.es1591.js";
import { Parser as h } from "./ghl-ui.es1670.js";
import { numericPatterns as v } from "./ghl-ui.es1672.js";
import { parseNDigits as P, parseNumericPattern as T } from "./ghl-ui.es1671.js";
var w = /* @__PURE__ */ function(u) {
  f(a, u);
  var i = l(a);
  function a() {
    var o;
    p(this, a);
    for (var r = arguments.length, e = new Array(r), t = 0; t < r; t++)
      e[t] = arguments[t];
    return o = i.call.apply(i, [this].concat(e)), n(s(o), "priority", 70), n(s(o), "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]), o;
  }
  return c(a, [{
    key: "parse",
    value: function(r, e, t) {
      switch (e) {
        case "k":
          return T(v.hour24h, r);
        case "ko":
          return t.ordinalNumber(r, {
            unit: "hour"
          });
        default:
          return P(e.length, r);
      }
    }
  }, {
    key: "validate",
    value: function(r, e) {
      return e >= 1 && e <= 24;
    }
  }, {
    key: "set",
    value: function(r, e, t) {
      var m = t <= 24 ? t % 24 : t;
      return r.setUTCHours(m, 0, 0, 0), r;
    }
  }]), a;
}(h);
export {
  w as Hour1To24Parser
};
